export const AppFooter = () => {
  return <footer />;
};
